
import React from'react';
import MenuSocials from '../components/MenuSocials';


const Footer = () => {
    return (
        <>
            <footer>
            <MenuSocials/>
                <div>
                    <div className='copyright'>
                        <p>Design & développement © Romain Kordalski 2024</p>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;